// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"776":"505ef625","944":"fd95e5de"}[chunkId] + ".chunk.css";
};